



































import { Component, Mixins, Prop } from "vue-property-decorator";
import { ElDialog } from "element-ui/types/dialog";
import { DialogMixin } from "../../../../../../system/mixins";
import { Patient } from "../../../../../../../domain/patient";
import { Department } from "../../../../../../../domain/department";
import { IClaioImageSource } from "../../../../../../../domain/claio";
import ClaioContentsTool from "../../../../contents/tools/wizard/guest/ClaioContentsTool.vue";

@Component({
  components: {
    ClaioContentsTool,
  },
})
export default class ClaioImageSelectableDialog extends Mixins(DialogMixin) {
  @Prop()
  patient: Patient;

  @Prop()
  department: Department;

  @Prop()
  orderNo: string;

  data(): any {
    return {
      shouldApply: false,
      selectedImageSource: null,
      isFixed: false,
    };
  }
  shouldApply: boolean;
  selectedImageSource: IClaioImageSource;
  isFixed: boolean;

  $refs!: {
    dialog: ElDialog,
    footer: HTMLDivElement,
    fixed: HTMLDivElement,
  };

  get referencePatient(): Patient {
    return !!this.patient && this.isVisible
      ? this.patient
      : null;
  }

  get referenceDepartment(): Department {
    return !!this.department && this.isVisible
      ? this.department
      : null;
  }

  get referenceOrderNo(): string {
    return !!this.orderNo && this.isVisible
      ? this.orderNo
      : null;
  }

  get fixedStyle(): any {
    return this.isFixed
      ? {
        position: "fixed",
        bottom: 0,
        width: "95vw",
      }
      : null;
  }

  async show(): Promise<IClaioImageSource> {
    await this.showModal(async () => {
      await this.initialize();
      this.updateLayout();
      await this.waitHidden();
      this.cleanup();
    });
    return this.shouldApply
      ? this.selectedImageSource
      : null;
  }

  private async initialize(): Promise<void> {
    this.shouldApply = false;
    this.selectedImageSource = null;
    await this.$nextTick();
    window.addEventListener("resize", this.updateLayout);
    this.$refs.dialog.$el.addEventListener("scroll", this.updateLayout);
  }

  private updateLayout(): void {
    this.$refs.footer.style.height = this.$refs.fixed.clientHeight + "px";
    const dialog = this.$refs.dialog.$el;
    this.isFixed = (dialog.scrollHeight - dialog.scrollTop - 50) > dialog.clientHeight; // el-dialogのマージン分(50px)を考慮
  }

  private cleanup(): void {
    window.removeEventListener("resize", this.updateLayout);
    this.$refs.dialog.$el.removeEventListener("scroll", this.updateLayout);
  }

  onSelected(newValue: IClaioImageSource) {
    this.selectedImageSource = newValue;
    this.$nextTick(() => {
      this.updateLayout();
    });
  }

  onApplyClicked(): void {
    this.shouldApply = true;
    this.isVisible = false;
  }

  onCloseClicked(): void {
    this.isVisible = false;
  }
}
